import { render, staticRenderFns } from "./FileNotificationsDropdown.vue?vue&type=template&id=88028156&"
import script from "./FileNotificationsDropdown.vue?vue&type=script&lang=js&"
export * from "./FileNotificationsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports